<template>
    <!-- begin login -->
    <div v-if="isSuccess" style="padding-top: 10%;">
        <div class="container p-5 card shadow">
            <b-row class="p-5">
                <b-col>
                    <div style="margin-top: 20%; margin-left: 6%;">
                        <h1>
                            <i class="fa fa-check-circle text-success"></i>
                            REGISTRASI PEGAWAI BERHASIL
                        </h1>
                        <p>
                            Terima kasih telah mendaftarkan diri anda di
                            aplikasi ini. <br />
                            User login anda akan dikirimkan melalui email anda.
                        </p>
                        <hr />
                        <div class="py-3">
                            <b-card
                                class="bg-teal-transparent-6 border-0 text-white"
                            >
                                <b-row>
                                    <b-col md="2">
                                        <img
                                            :src="logoSumut"
                                            alt="logo"
                                            class="w-100"
                                        />
                                    </b-col>
                                    <b-col>
                                        <div class="h6">
                                            PEMERINTAH PROVINSI SUMATERA UTARA
                                        </div>
                                        <div class="h5">
                                            BADAN PENGELOLAAN PAJAK DAN
                                            RETRIBUSI DAERAH
                                        </div>
                                        <div style="font-size: 10px;">
                                            BIDANG RETRIBUSI DAN PENDAPATAN LAINNYA
                                        </div>
                                        <div style="font-size: 8px;">
                                            <i
                                                class="fas fa-map-marker-alt"
                                            ></i>
                                            Jl. Sisingamangaraja Km 5,5 Medan
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </div>
                        <hr />
                        <b-nav fill>
                            <b-nav-item to="/auth/login">
                                <h6>LOGIN</h6>
                            </b-nav-item>
                            <b-nav-item to="/auth/daftar">
                                <h6>REGISTRASI AKUN BADAN USAHA</h6>
                            </b-nav-item>
                            <b-nav-item @click="toPegawai">
                                <h6>REGISTRASI DATA PEGAWAI</h6>
                            </b-nav-item>
                        </b-nav>
                    </div>
                </b-col>
                <b-col md="6">
                    <img :src="success" alt="success" class="w-100" />
                </b-col>
            </b-row>
        </div>
    </div>
    <div class="py-5" v-else>
        <b-row class="container-fluid">
            <b-col offset="1" md="10">
                <b-row class="shadow">
                    <b-col class="bg-teal-transparent-4" md="5">
                        <div class="text-center" style="margin-top: 200px;">
                            <img
                                :src="logoSumut"
                                alt="logo"
                                style="width: 200px;"
                            />
                        </div>
                        <div class="text-center">
                            <h1>BUMD</h1>
                            <h2>(BADAN USAHA MILIK DAERAH)</h2>
                            <h5>PEMERINTAH PROVINSI SUMATERA UTARA</h5>
                            <div class="my-5 d-flex justify-content-center">
                                <b-button
                                    variant="light"
                                    block
                                    class="w-50"
                                    pill
                                    to="/auth/login"
                                    :disabled="isLoading"
                                >
                                    Login
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="7" class="py-3">
                        <h3 class="pt-3">
                            FORM REGISTRASI DATA PEGAWAI
                        </h3>
                        <p>
                            Lengkapi data di bawah ini untuk mendaftarkan
                            pegawai.
                        </p>
                        <h4 class="py-2">
                            DATA PEGAWAI
                        </h4>
                        <form
                            @submit.prevent="store"
                            @keydown="form.onKeydown($event)"
                            autocomplete="off"
                        >
                            <b-card>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >PERANGKAT
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-md-7">
                                        <v-select
                                            label="nama"
                                            :options="
                                                PemerintahReg.perangkatOptions
                                            "
                                            :reduce="nama => nama.id"
                                            v-model="helper.perangkat_id"
                                            :class="{
                                                'style-chooser': form.errors.has(
                                                    'unit_pd_id'
                                                )
                                            }"
                                            @input="
                                                inputPerangkat(
                                                    helper.perangkat_id
                                                )
                                            "
                                            placeholder="Pilih Perangkat"
                                            :disabled="isLoading"
                                        >
                                        </v-select>
                                        <em
                                            v-if="
                                                form.errors.has('unit_pd_id') &&
                                                    helper.errors
                                            "
                                            class="form-text text-danger"
                                            >Bagian Isian Perangkat Wajib
                                            Diisi.</em
                                        >
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >UNIT
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-md-7">
                                        <v-select
                                            label="nama"
                                            :options="PemerintahReg.unitOptions"
                                            :reduce="nama => nama.id"
                                            v-model="form.unit_pd_id"
                                            :class="{
                                                'style-chooser': form.errors.has(
                                                    'unit_pd_id'
                                                )
                                            }"
                                            placeholder="Pilih Unit"
                                            :disabled="isLoading"
                                        >
                                        </v-select>
                                        <em
                                            v-if="
                                                form.errors.has('unit_pd_id') &&
                                                    helper.errors
                                            "
                                            class="form-text text-danger"
                                            >{{
                                                helper.errors.unit_pd_id[0]
                                            }}</em
                                        >
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >NIK
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'nik'
                                                        )
                                                    }"
                                                    v-model="form.nik"
                                                    placeholder="Masukkan NIK"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'nik'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.nik[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >NIP
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'nip'
                                                        )
                                                    }"
                                                    v-model="form.nip"
                                                    placeholder="Masukkan NIP"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'nip'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.nip[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >NAMA
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'nama'
                                                        )
                                                    }"
                                                    v-model="form.nama"
                                                    placeholder="Masukkan Nama"
                                                    :disabled="isLoading"
                                                    style="text-transform: uppercase;"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'nama'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.nama[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >JENIS KELAMIN
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div
                                                    class="radio radio-css radio-inline"
                                                >
                                                    <input
                                                        type="radio"
                                                        id="inlineCssRadio1"
                                                        value="laki-laki"
                                                        v-model="
                                                            form.jenis_kelamin
                                                        "
                                                        :disabled="isLoading"
                                                    />
                                                    <label for="inlineCssRadio1"
                                                        >Laki-laki</label
                                                    >
                                                </div>
                                                <div
                                                    class="radio radio-css radio-inline"
                                                >
                                                    <input
                                                        type="radio"
                                                        id="inlineCssRadio2"
                                                        value="perempuan"
                                                        v-model="
                                                            form.jenis_kelamin
                                                        "
                                                        :disabled="isLoading"
                                                    />
                                                    <label for="inlineCssRadio2"
                                                        >Perempuan</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <em
                                            v-if="
                                                form.errors.has(
                                                    'jenis_kelamin'
                                                ) && helper.errors
                                            "
                                            class="form-text text-danger"
                                            >{{
                                                helper.errors.jenis_kelamin[0]
                                            }}</em
                                        >
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >TEMPAT LAHIR
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'tmp_lahir'
                                                        )
                                                    }"
                                                    v-model="form.tmp_lahir"
                                                    placeholder="Masukkan Tempat Lahir"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'tmp_lahir'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors
                                                            .tmp_lahir[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >TANGGAL LAHIR
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-5">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="input-group">
                                                    <date-picker
                                                        id="dateTimeInput"
                                                        :config="options"
                                                        v-model="form.tgl_lahir"
                                                        placeholder="-Pilih Tanggal-"
                                                        :class="{
                                                            'is-invalid': form.errors.has(
                                                                'tgl_lahir'
                                                            )
                                                        }"
                                                        :disabled="isLoading"
                                                    >
                                                    </date-picker>
                                                    <div
                                                        class="input-group-append"
                                                    >
                                                        <label
                                                            for="dateTimeInput"
                                                            class="input-group-text"
                                                        >
                                                            <i
                                                                class="fa fa-calendar"
                                                            ></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <em
                                            v-if="
                                                form.errors.has('tgl_lahir') &&
                                                    helper.errors
                                            "
                                            class="form-text text-danger"
                                            >{{
                                                helper.errors.tgl_lahir[0]
                                            }}</em
                                        >
                                    </div>
                                </div>
                            </b-card>
                            <h4 class="pt-4">
                                KONTAK & ALAMAT
                            </h4>
                            <b-card>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >NO. HANDPHONE
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'nomp'
                                                        )
                                                    }"
                                                    v-model="form.nomp"
                                                    placeholder="Masukkan Nomor Handphone"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'nomp'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.nomp[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >EMAIL
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'email'
                                                        )
                                                    }"
                                                    v-model="form.email"
                                                    placeholder="Masukkan Email"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'email'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.email[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >ALAMAT
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'alamat'
                                                        )
                                                    }"
                                                    v-model="form.alamat"
                                                    placeholder="Masukkan Alamat"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'alamat'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >{{
                                                        helper.errors.alamat[0]
                                                    }}</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >PROVINSI
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <v-select
                                                    label="nama"
                                                    :options="
                                                        WilayahReg.provinsi
                                                    "
                                                    :reduce="nama => nama.id"
                                                    v-model="wilayah.provinsi"
                                                    :class="{
                                                        'style-chooser': form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        )
                                                    }"
                                                    @input="
                                                        onProvinsi(
                                                            wilayah.provinsi
                                                        )
                                                    "
                                                    placeholder="Pilih Provinsi"
                                                    :disabled="isLoading"
                                                >
                                                </v-select>
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >Bagian isian Provinsi wajib
                                                    diisi.</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >KABKOTA
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <v-select
                                                    label="nama"
                                                    :options="
                                                        WilayahReg.kabkota
                                                    "
                                                    :reduce="nama => nama.id"
                                                    :class="{
                                                        'style-chooser': form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        )
                                                    }"
                                                    v-model="wilayah.kabkota"
                                                    @input="
                                                        onKabkota(
                                                            wilayah.kabkota
                                                        )
                                                    "
                                                    placeholder="Pilih Kab./Kota"
                                                    :disabled="isLoading"
                                                >
                                                </v-select>
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >Bagian isian Kab./Kota
                                                    wajib diisi.</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >KECAMATAN
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <v-select
                                                    label="nama"
                                                    :options="
                                                        WilayahReg.kecamatan
                                                    "
                                                    :reduce="nama => nama.id"
                                                    :class="{
                                                        'style-chooser': form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        )
                                                    }"
                                                    v-model="wilayah.kecamatan"
                                                    @input="
                                                        onKecamatan(
                                                            wilayah.kecamatan
                                                        )
                                                    "
                                                    placeholder="Pilih Kecamatan"
                                                    :disabled="isLoading"
                                                >
                                                </v-select>
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                    >Bagian isian Kecamatan
                                                    wajib diisi.</em
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >KELURAHAN
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <v-select
                                                    label="nama"
                                                    :options="
                                                        WilayahReg.kelurahan
                                                    "
                                                    :reduce="nama => nama.id"
                                                    :class="{
                                                        'style-chooser': form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        )
                                                    }"
                                                    v-model="
                                                        form.wilayah_kelurahan_id
                                                    "
                                                    placeholder="Pilih Kelurahan"
                                                    :disabled="isLoading"
                                                >
                                                </v-select>
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'wilayah_kelurahan_id'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                >
                                                    {{
                                                        helper.errors
                                                            .wilayah_kelurahan_id[0]
                                                    }}
                                                </em>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-4 col-form-label font-weight-bold"
                                        >KODEPOS
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': form.errors.has(
                                                            'kodepos'
                                                        )
                                                    }"
                                                    v-model="form.kodepos"
                                                    placeholder="Masukkan Kodepos"
                                                    :disabled="isLoading"
                                                />
                                                <em
                                                    v-if="
                                                        form.errors.has(
                                                            'kodepos'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                >
                                                    {{
                                                        helper.errors.kodepos[0]
                                                    }}
                                                </em>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                            <div class="py-3">
                                <span>
                                    <b-button variant="primary" type="submit">
                                        <b-spinner
                                            variant="light"
                                            label="Spinning"
                                            small
                                            v-if="isLoading"
                                        ></b-spinner>
                                        <i class="fa fa-pen-square" v-else></i>
                                        Registrasi Pegawai
                                    </b-button>
                                </span>
                            </div>
                        </form>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
    <!-- end login -->
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars

import PageOptions from "@/config/PageOptions.vue";
import Logo from "@/assets/images/logoSumut.png";
import success from "@/assets/images/success.jpg";
import { mapState } from "vuex";
import pegawaiRegMixins from "@/helper/pegawai/pegawai_reg";

export default {
    mixins: [pegawaiRegMixins],
    data() {
        return {
            // logo dan gambar
            logoSumut: Logo,
            success: success,
            //=========
            form: new Form({
                email: "",
                password: ""
            }),
            errors: [],
            message: "",
            isLoading: false,
            isSuccess: false,
            // csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            helper: {
                perangkat_id: "",
                errors: ""
            },
            // datepicker config
            options: {
                format: "YYYY-MM-DD",
                useCurrent: true,
                minDate: "1900-01-01"
            },
            // wilayah
            wilayah: {
                provinsi: "",
                kabkota: "",
                kecamatan: ""
            },
            // form variable
            form: new Form({
                unit_pd_id: "",
                nik: "",
                nip: "",
                nama: "",
                jenis_kelamin: "",
                tmp_lahir: "",
                tgl_lahir: "",
                nomp: "",
                email: "",
                alamat: "",
                wilayah_kelurahan_id: "",
                kodepos: ""
            })
        };
    },
    created() {
        PageOptions.pageEmpty = true;
        document.body.className = "bg-white";
    },
    beforeRouteLeave(to, from, next) {
        PageOptions.pageEmpty = false;
        document.body.className = "";
        next();
    },
    computed: {
        ...mapState(["PemerintahReg", "WilayahReg"])
    },
    mounted() {
        // vuex - call untuk data perangkat
        this.$store.dispatch("PemerintahReg/getPerangkatOptions");
        // vuex - call wilayah provinsi
        this.$store.dispatch("WilayahReg/getProvinsi");
        if (JSON.parse(localStorage.getItem("saveMode"))) {
            this.isSuccess = true;
        } else {
            this.isSuccess = false;
        }
    },
    methods: {
        // ketika perangkat di panggil
        inputPerangkat(perangkat_id) {
            if (perangkat_id) {
                // vue - call unit by perangkat id
                this.$store.dispatch(
                    "PemerintahReg/getUnitOptions",
                    perangkat_id
                );
            } else {
                return false;
            }
        },
        // provinsi
        onProvinsi(provinsi_id) {
            if (this.wilayah.provinsi) {
                this.$store.dispatch("WilayahReg/getKabkota", provinsi_id);
            } else {
                this.$store.commit("WilayahReg/kabkota", []);
                this.wilayah = {
                    kabkota: "",
                    kecamatan: ""
                };
                this.form.wilayah_kelurahan_id = "";
            }
        },
        // kabkota
        onKabkota(kabkota_id) {
            if (this.wilayah.kabkota) {
                this.$store.dispatch("WilayahReg/getKecamatan", kabkota_id);
            } else {
                this.$store.commit("WilayahReg/kecamatan", []);
                this.wilayah = {
                    kecamatan: ""
                };
                this.form.wilayah_kelurahan_id = "";
            }
        },
        // kecamatan
        onKecamatan(kecamatan_id) {
            if (this.wilayah.kecamatan) {
                this.$store.dispatch("WilayahReg/getKelurahan", kecamatan_id);
            } else {
                this.$store.commit("WilayahReg/kelurahan", []);
                this.form.wilayah_kelurahan_id = "";
            }
        },
        toPegawai() {
            this.isSuccess = false;
            localStorage.setItem("saveMode", false);
        }
    }
};
</script>

<style>
.image-latar {
    background-color: rgb(162, 193, 240);
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
.slide-fade-enter-active {
    transition: all 0.2s ease;
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}
</style>
